import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import LabelText from '../../LabelText';
import Year from './Year';
import Month from './Month';
import Day from './Day';

const Birthday = (props) => {
	const { t, i18n } = useTranslation();

	const {form_component} = props;

	const userData = useSelector(state => state.userData);

	return (
		<div className={`flex-grow-1 form-group text ${form_component.required ? 'required' : ''}`}>
			<LabelText
				lang={props.lang}
				form_component={form_component}
			/>
			<div className="d-flex align-items-center flex-wrap gap-2">
				{form_component.show_date_year && (
					<Year
						lang={props.lang}
						form_component={form_component}
					/>
				)}
				{form_component.show_date_month && (
					<Month
						lang={props.lang}
						form_component={form_component}
					/>
				)}
				{form_component.show_date_day && (
					<Day
						lang={props.lang}
						form_component={form_component}
					/>
				)}
			</div>
		</div>
	);
}

export default Birthday;